import { render, staticRenderFns } from "./serviceSystem.vue?vue&type=template&id=629641a3&scoped=true"
import script from "./serviceSystem.vue?vue&type=script&lang=js"
export * from "./serviceSystem.vue?vue&type=script&lang=js"
import style0 from "./serviceSystem.vue?vue&type=style&index=0&id=629641a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629641a3",
  null
  
)

export default component.exports